(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dfb-shop-category"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-dfb-category-slider]').forEach((slider) => {
    if (slider.dataset.ready) return;
    slider.dataset.ready = '1';
    const track = slider.querySelector('.dfb-shop-category__track');
    const prev = slider.querySelector('.dfb-category-nav--prev');
    const next = slider.querySelector('.dfb-category-nav--next');
    const dots = slider.parentElement.querySelector('.dfb-category-dots');
    const cards = [...track.children];
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    };
    const move = (dir) => track.scrollBy({left: dir * Math.max(track.clientWidth / 5, 220), behavior: 'smooth'});
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    update();
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dfb-tagged-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.dfbTaggedBuyBound) return;
  window.dfbTaggedBuyBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-dfb-tagged-buy]');
    if (!button) return;
    const variantId = button.getAttribute('data-dfb-tagged-buy');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Processing...';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:Number(variantId), quantity:1}]})
      });
      if (!response.ok) throw new Error('Unable to add product');
      window.location.href = '/checkout';
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      alert('Unable to process your order. Please try again.');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
